<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<img :src="'./images/exam_home.jpg'" style="width: 100%;" />

		<img src="https://zhaosheng-saas.oss-cn-hangzhou.aliyuncs.com/files/2022-6-29/1656490506591791.png?s=430_430" style="width: 50%; border-radius: 40%; display: block; margin: 0 auto;" />

		<div style="text-align: center; line-height: 100px;">请扫描二维码或点击下方按钮开始登记</div>

		<div style="text-align: center; line-height: 50px;">
			<el-button type="primary">
				<a :href="wxurl" style="color: #fff; text-decoration: none;">开始登记</a>
			</el-button>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			wxurl: ""


		}
	},
	mounted() {

		document.title = "欢迎来到昆山第一中专"
		this.pmid = 12
		this.getUrl()

	},
	methods: {
		getUrl() {
			this.$http.post("/api/get_wxmini_weburl", { pmid: 12,t:"bk" }).then(res => {
				this.wxurl = res.data.openlink
			})
		}
	},
}
</script>
